<template>
  <div class="scroll-section">

    <header class="clients-header">
      <h1 v-html="$t('clients.header')"></h1>
    </header>

    <div class="VueCarousel">
      <div class="VueCarousel-wrapper">
        <div class="VueCarousel-inner" ref="carouselinner">
          <div class="VueCarousel-slide" v-for="(slide, index) in logos" :class="index" :key="index"
            :ref="'carouselslide' + index">
            <div class="slide-image" :class="className" v-for="(imgSrc, className) in slide">
              <img :src="imgSrc">
            </div>
          </div>
        </div>
      </div>

      <div class="VueCarousel-pagination">
        <div class="VueCarousel-dot-container">
          <div class="VueCarousel-dot" :class="{'VueCarousel-dot--active':carouselIndex===0}" @click="carouselClick(0)">
            <div class="VueCarousel-dot-inner"></div>
          </div>
          <div class="VueCarousel-dot" :class="{'VueCarousel-dot--active':carouselIndex===1}" @click="carouselClick(1)">
            <div class="VueCarousel-dot-inner"></div>
          </div>
          <div class="VueCarousel-dot" :class="{'VueCarousel-dot--active':carouselIndex===2}" @click="carouselClick(2)">
            <div class="VueCarousel-dot-inner"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import logoDR from '../.././assets/logo_dr.svg';
import logoGrundfos from '../.././assets/logo_grundfos.svg';
import logoInterflora from '../.././assets/logo_interflora.svg';
import logoKMD from '../.././assets/logo_kmd.svg';
import logoMidt from '../.././assets/logo_midt.svg';
import logoNestle from '../.././assets/logo_nestle.svg';
import logoPfizer from '../.././assets/logo_pfizer.svg';
import logoRoskilde from '../.././assets/logo_roskilde.svg';
import logoTulip from '../.././assets/logo_tulip.svg';
import logoVega from '../.././assets/logo_vega.png';
import logoVestas from '../.././assets/logo_vestas.svg';
import logoVisma from '../.././assets/logo_visma.svg';

import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'Clients',
  data() {
    return {
      carouselIndex: 0,
      exclude_from_nav: true,
      nav_title: 'clients',
      logos: [
        {
          grundfos: logoGrundfos,
          interflora: logoInterflora,
          kmd: logoKMD,
          dr: logoVisma, // logoDr
        }, {
          nestle: logoNestle,
          pfizer: logoPfizer,
          regmidt: logoMidt,
          roskilde: logoRoskilde
        }, {
          tulip: logoTulip,
          vega: logoVega,
          vestas: logoVestas,
          visma: logoVisma
        }
      ]
    };
  },
  watch: {
    active_section_name(val) {
      if (val === 'passion') {
        if (!this.is_animating_scroll) {
          this.loopedAnimationsPaused = false;
        }
      } else {
        this.loopedAnimationsPaused = true;
      }
    },
    scroll_pos(val) {
      if (this.scroll_pos > (this.$el.offsetTop - 200) && this.scroll_pos < ((this.elHeight - 200) + this.$el.offsetTop)) {
        if (!this.is_animating_scroll) {
          this.setActiveSection(this.$options._componentTag);
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      active_section_name: 'getActiveSectionName',
      scroll_pos: 'getScrollPos',
      is_animating_scroll: 'getAnimatingScrollState'
    }),
    elHeight() {
      return Math.ceil(this.$el.getBoundingClientRect().height);
    }
  },
  methods: {
    ...mapActions([
      'setActiveSection',

    ]),
    initCarouselClickAutomation() {
      if (this.carouselClickAutomationTimer) {
        clearInterval(this.carouselClickAutomationTimer);
      }
      this.carouselClickAutomationTimer = setInterval(() => {
        let index = this.carouselIndex;
        if (this.$refs['carouselslide' + (index + 1)]) {
          index++;
        } else {
          index = 0;
        }
        this.carouselSetIndex(index);
      }, 2000);
    },
    carouselSetIndex(index) {
      index = typeof index === 'undefined' ? this.carouselIndex : index;
      let el = this.$refs['carouselslide' + index];
      if (!el) return;
      //let width = el[0].offsetWidth;
      //width = el[0].parentNode.getBoundingClientRect() / 3;
      //let rect = el[0].getBoundingClientRect();
      //console.log(el[0].offsetWidth, el[0].clientWidth, el[0].outerWidth, el[0].scrollWidth);
      // xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
      // yPos += (el.offsetTop - el.scrollTop + el.clientTop);
      let width = document.querySelector('.VueCarousel').scrollWidth;
      let x = index * (0 - width);
      if (this.$refs.carouselinner) {
        this.$refs.carouselinner.style.transform = `translateX(${x}px)`;
      }
      this.carouselIndex = index;
    },

    carouselClick(index) {
      this.initCarouselClickAutomation();
      this.carouselSetIndex(index);
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.carouselClick();
    });
    this.initCarouselClickAutomation();
  }
};
</script>

<style lang="scss" scoped>
.scroll-section {
  position: relative;
  z-index: 2;
  padding-top: 46px;
  padding-bottom: 14px;
  overflow: visible;
  overflow-x: visible;
  background-color: rgba(255, 255, 255, .85);
}
</style>

<style lang="scss">
.clients-header {
  text-align: center;
  margin-bottom: 1rem;

  h1 {
    font-size: 3rem;
    text-transform: uppercase;
    font-weight: 100;
    @media screen and (max-width: 768px) {
      font-size: 1.3rem;
    }
  }
}

.slide-image {
  /*
  flex-basis: inherit;
  flex-grow: 0;
  flex-shrink: 0;
  flex-shrink: initial !important;
  */

  display: inline-block;
  float: none;
  vertical-align: middle;

  img {
    display: inline-block;
    vertical-align: middle;
  }

  user-select: none;
  width: 25%;
  padding: 0 6%;

  @media screen and (max-width: 768px) {
    /*
    width: 40%;
    position: absolute;
    height: 150px;
    */
    /*
    display: flex;
    justify-content: center;
    align-items: center;
    */
    &:nth-child(2) {
      //left: 50%;
    }
    &:nth-child(3) {
      //top: 50%;
    }
    &:nth-child(4) {
      //left: 50%;
      //top: 50%;
    }
  }

  &.dr {
    padding: 4%;
    padding-top: 1%;
    padding-bottom: 0%;
  }

  &.grundfos {
    padding: 0;
    padding-top: 0;
    padding-bottom: 1%;
  }

  &.interflora {
    padding: 7%;
    padding-top: 0;
    padding-bottom: 0;
  }

  &.kmd {
    padding: 5%;
    padding-top: 1%;
    padding-bottom: 1%;
  }

  &.regmidt {
    padding: 5%;
    padding-top: 0%;
    padding-bottom: 0%;
  }

  &.roskilde {
    padding: 2%;
    padding-top: 1%;
    padding-bottom: 1%;
  }

  &.vega {
    padding: 6%;
    padding-top: 2%;
    padding-bottom: 0%;
  }

  &.vestas {
    padding: 4%;
    padding-top: 2%;
    padding-bottom: 0%;
  }

  &.visma {
    padding: 4%;
    padding-top: 3%;
    padding-bottom: 0%;
  }

  &.nestle {
    padding: 0 4%;
  }

  &.pfizer {
    padding: 0 7%;
  }

  &.tulip {
    padding: 3%;
    padding-top: 3%;
    padding-bottom: 0%;
  }

  img {
    max-height: 180px;
  }
}

.VueCarousel {
  position: relative;
  //max-width: 80vw;
  //border: 1px solid red;
  overflow: hidden;
  margin: 0 auto;
}

.VueCarousel-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.VueCarousel-inner {
  transition: transform 0.7s cubic-bezier(0.6, 0.01, 0.32, 0.99);
  backface-visibility: hidden;
  transform: translateX(0px);
  visibility: visible;
  /*
  display: flex;
  flex-basis: 100%;
  flex-direction: row;
  */

  display: block;
  width: calc(100vw * 3);
  overflow: hidden;
  height: auto;
}

.VueCarousel-slide {
  user-select: none;
  /*
  display: flex;
  flex-basis: inherit;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  */

  position: relative;
  display: block;
  float: left;
  width: 100vw;
  clear: right;
  margin: 0 auto;
  max-width: 80vw;
  margin-left: 10vw;
  margin-right: 10vw;

  @media screen and (max-width: 768px) {
    //position: relative;
    //padding: 0 2rem;
    //padding-bottom: 400px;
    /*justify-content: flex-start;
    align-items: flex-start;*/
  }
}

.VueCarousel-pagination {
  width: 100%;
  text-align: center;
  float: none !important;
  margin-top: .5rem;
  margin-bottom: 1.5rem;
  @media screen and (max-width: 768px) {
    margin-top: 0;
  }

  .VueCarousel-dot-container {
    display: inline-block;
    margin: 0 auto;
  }
}

.VueCarousel-dot {
  float: left;
  cursor: pointer;
  margin-top: 20px;
  padding: 10px;

  .VueCarousel-dot-inner {
    width: 10px;
    height: 10px;
    border-radius: 0 !important;
    transition: all .3s cubic-bezier(.43, .97, .56, .97);
    background: rgb(206, 211, 214);
  }

  &--active {
    .VueCarousel-dot-inner {
      transform: scale(1.5);
      box-shadow: 0px 0px 10px 2px rgba(0, 158, 255, .18);
      background: rgb(91, 177, 230);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sections/Clients.vue